<template>
  <el-dialog
    :title="model.id > 0 ? '编辑供应商' : '新增供应商'"
    :visible.sync="visible"
    label-width="100px"
    width="40%"
    @close="$emit('update:show', false)"
  >
    <el-form :model="model" :rules="rules" ref="form" label-width="100px" size="small">
      <el-form-item label="名称" prop="name">
        <el-input v-model="model.name" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item label="地区">
        <el-cascader class="long" :options="regionData" v-model="model.area"></el-cascader>
      </el-form-item>
      <el-form-item label="地址" prop="address_detail">
        <el-input v-model="model.address_detail" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item label="联系人名称" prop="contact_name">
        <el-input v-model="model.contact_name" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item label="联系人电话" prop="contact_phone_number">
        <el-input v-model="model.contact_phone_number" autocomplete="off"></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button size="small" @click="visible = false">取 消</el-button>
      <el-button size="small" type="primary" @click="submitForm">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { regionData } from '@/util/area_tool'
import { createSupplier, updateSupplier } from '@/service/getData'

export default {
  props: {
    model: {
      type: Object
    },
    show: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    show() {
      this.visible = this.show
      if (!this.visible) {
        this.$refs.form.resetFields()
      }
    },
    model() {
      if (this.model.id > 0) {
        this.model.area = [
          this.model.province_id,
          this.model.city_id,
          this.model.county_id
        ]
      }
    }
  },
  data() {
    return {
      visible: this.show,
      regionData: regionData,
      rules: {
        name: [
          { required: true, message: '请输入名称', trigger: 'blur' },
          { min: 2, max: 15, message: '长度在 2 到 15 个字符', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    submitForm() {
      this.$refs.form.validate(async valid => {
        if (valid) {
          let area = this.model.area
          if (area && area.length > 0) {
            this.model.province_id = area[0]
          }
          if (area && area.length > 1) {
            this.model.city_id = area[1]
          }
          if (area && area.length > 2) {
            this.model.county_id = area[2]
          }
          if (this.model.id > 0) {
            let res = await updateSupplier(this.model)
            if (res.code == 0) {
              this.$emit('updated', res.data)
            }
          } else {
            let res = await createSupplier(this.model)
            if (res.code == 0) {
              this.$emit('created', res.data)
            }
          }
          this.visible = false
        } else {
          console.log('error submit!!')
          return false
        }
      })
    }
  }
}
</script>